import { openDB } from 'idb';
import { DB_NAME, STORE_NAME, DB_VERSION } from './dbConfig';

export const initDB = async () => {
    return await openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        },
    });
};
